import React, { useState, useEffect } from 'react';
import { db, auth, getCollectionName } from './firebase';
import { collection, addDoc, onSnapshot, query, orderBy } from './firestore-compat';
import { toTitleCase } from './utils/formatters';

const TRANSPORT_TYPES = ['Ônibus', 'Trem', 'Metrô', 'Barca', 'Van'];
const FILIAIS = ['Homebaby', 'Vitalcare'];

export default function FormularioPassagem() {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [profissionais, setProfissionais] = useState([]);

  const [formData, setFormData] = useState({
    tecnicaNome: '',
    filial: '',
    dataVisita: new Date().toISOString().split('T')[0],
    pacienteNome: '',
    tempoTreinamento: '',
    enderecoPaciente: '',
    
    qtdTransportesIda: 1,
    transporteIda: [
      { tipo: '', linha: '', valor: '' },
      { tipo: '', linha: '', valor: '' },
      { tipo: '', linha: '', valor: '' }
    ],
    
    qtdTransportesVolta: 1,
    transporteVolta: [
      { tipo: '', linha: '', valor: '' },
      { tipo: '', linha: '', valor: '' },
      { tipo: '', linha: '', valor: '' }
    ],
    valorAlimentacao: 25
  });

  useEffect(() => {
    const unsub = onSnapshot(query(collection(db, getCollectionName('profissionais_parceiros')), orderBy('nome')), snap => {
      setProfissionais(snap.docs.map(d => ({ id: d.id, nome: d.data().nome })));
    });
    return () => unsub();
  }, []);

  const handleNext = () => setStep(prev => prev + 1);
  const handlePrev = () => setStep(prev => prev - 1);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const totalIda = formData.transporteIda.slice(0, formData.qtdTransportesIda).reduce((acc, curr) => acc + Number(curr.valor || 0), 0);
      const totalVolta = formData.transporteVolta.slice(0, formData.qtdTransportesVolta).reduce((acc, curr) => acc + Number(curr.valor || 0), 0);
      const alimentacao = Number(formData.valorAlimentacao || 25);
      
      const payload = {
        ...formData,
        tecnicaNome: toTitleCase(formData.tecnicaNome),
        pacienteNome: toTitleCase(formData.pacienteNome),
        totalPassagem: totalIda + totalVolta,
        totalIda,
        totalVolta,
        totalGeral: totalIda + totalVolta + alimentacao,
        criadoEm: new Date().toISOString(),
        criadoPor: auth.currentUser?.email || 'anon'
      };

      await addDoc(collection(db, 'passagens_tecnicos'), payload);
      alert('Formulário enviado com sucesso!');
      setStep(1);
      setFormData({
        tecnicaNome: '', filial: '', dataVisita: new Date().toISOString().split('T')[0],
        pacienteNome: '', tempoTreinamento: '', enderecoPaciente: '',
        qtdTransportesIda: 1,
        transporteIda: [{ tipo: '', linha: '', valor: '' }, { tipo: '', linha: '', valor: '' }, { tipo: '', linha: '', valor: '' }],
        qtdTransportesVolta: 1,
        transporteVolta: [{ tipo: '', linha: '', valor: '' }, { tipo: '', linha: '', valor: '' }, { tipo: '', linha: '', valor: '' }]
      });
    } catch (err) {
      console.error(err);
      alert('Erro ao enviar formulário.');
    } finally {
      setLoading(false);
    }
  };

  const renderTransportBlock = (type, index) => {
    const list = type === 'ida' ? formData.transporteIda : formData.transporteVolta;
    const update = (field, val) => {
      const newList = [...list];
      newList[index][field] = val;
      setFormData({ ...formData, [type === 'ida' ? 'transporteIda' : 'transporteVolta']: newList });
    };

    return (
      <div key={index} style={s.transBlock}>
        <h4 style={{margin: '0 0 10px', fontSize: '0.9rem', color: '#6366f1'}}>Transporte {index + 1}</h4>
        <div style={s.gridRow}>
          <div>
            <label style={s.label}>Meio de Locomoção</label>
            <select style={s.input} value={list[index].tipo} onChange={e => update('tipo', e.target.value)} required>
              <option value="">Selecione...</option>
              {TRANSPORT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div>
            <label style={s.label}>Linha (Ônibus/Van)</label>
            <input style={s.input} value={list[index].linha} onChange={e => update('linha', e.target.value)} placeholder="Ex: 474" />
          </div>
          <div>
            <label style={s.label}>Valor (R$)</label>
            <input type="number" step="0.01" style={s.input} value={list[index].valor} onChange={e => update('valor', e.target.value)} required placeholder="0,00" />
          </div>
        </div>
      </div>
    );
  };

  const s = {
    pageWrapper: { 
      minHeight: '100vh', 
      width: '100%', 
      background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%)',
      display: 'flex',
      justifyContent: 'center',
      padding: '40px 20px',
      boxSizing: 'border-box'
    },
    container: { maxWidth: '700px', width: '100%', fontFamily: "'Inter', sans-serif" },
    card: { background: '#fff', padding: '32px', borderRadius: '32px', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.3)' },
    title: { margin: '0 0 8px', fontSize: '1.8rem', fontWeight: 900, textAlign: 'center', color: '#000' },
    subtitle: { margin: '0 0 24px', fontSize: '0.95rem', color: '#000', textAlign: 'center', fontWeight: 600 },
    label: { display: 'block', marginBottom: '6px', fontSize: '0.85rem', fontWeight: 800, color: '#000' },
    input: { width: '100%', padding: '14px 16px', borderRadius: '16px', border: '1px solid #e2e8f0', background: '#fff', color: '#000', marginBottom: '16px', boxSizing: 'border-box', outline: 'none', fontWeight: 600 },
    gridRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' },
    transBlock: { background: '#f8fafc', padding: '16px', borderRadius: '16px', marginBottom: '16px', border: '1px solid #e2e8f0' },
    btn: { background: '#000', color: '#fff', border: 'none', padding: '16px 28px', borderRadius: '16px', cursor: 'pointer', fontWeight: 800, transition: 'all 0.2s', width: '100%', fontSize: '1rem' },
    btnGhost: { background: 'transparent', color: '#000', border: '2px solid #000', padding: '14px 28px', borderRadius: '16px', cursor: 'pointer', fontWeight: 800, width: '100%', marginBottom: '10px' },
    progress: { display: 'flex', gap: '8px', marginBottom: '24px', justifyContent: 'center' },
    dot: (active) => ({ width: '40px', height: '6px', borderRadius: '3px', background: active ? '#000' : 'rgba(0,0,0,0.1)', transition: 'all 0.3s' })
  };

  return (
    <div style={s.pageWrapper}>
      <div style={s.container}>
        <div style={s.card}>
        <h2 style={s.title}>🎫 Pagamento de Passagem</h2>
        <p style={s.subtitle}>Registro de deslocamento para treinamento/plantão</p>
        
        <div style={s.progress}>
          <div style={s.dot(step >= 1)}></div>
          <div style={s.dot(step >= 2)}></div>
          <div style={s.dot(step >= 3)}></div>
        </div>

        {step === 1 && (
          <div>
            <h3 style={{fontSize: '1.1rem', marginBottom: '20px'}}>Seção 1: Dados da Visita</h3>
            <label style={s.label}>Técnica de Enfermagem</label>
            <input style={s.input} list="tecnicas" value={formData.tecnicaNome} onChange={e => setFormData({...formData, tecnicaNome: e.target.value})} placeholder="Selecione ou digite..." required />
            <datalist id="tecnicas">
              {profissionais.map(p => <option key={p.id} value={p.nome}>{p.nome}</option>)}
            </datalist>

            <label style={s.label}>Filial</label>
            <select style={s.input} value={formData.filial} onChange={e => setFormData({...formData, filial: e.target.value})} required>
              <option value="">Selecione...</option>
              {FILIAIS.map(f => <option key={f} value={f}>{f}</option>)}
            </select>

            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px'}}>
              <div>
                <label style={s.label}>Data da Visita</label>
                <input type="date" style={s.input} value={formData.dataVisita} onChange={e => setFormData({...formData, dataVisita: e.target.value})} required />
              </div>
              <div>
                <label style={s.label}>Tempo de Treinamento/Plantão</label>
                <input style={s.input} value={formData.tempoTreinamento} onChange={e => setFormData({...formData, tempoTreinamento: e.target.value})} placeholder="Ex: 12h, 6h..." required />
              </div>
            </div>

            <label style={s.label}>Nome do Paciente</label>
            <input style={s.input} value={formData.pacienteNome} onChange={e => setFormData({...formData, pacienteNome: e.target.value})} placeholder="Nome completo do paciente" required />

            <div style={{display: 'grid', gridTemplateColumns: '1fr', gap: '16px'}}>
              <div>
                <label style={s.label}>Endereço do Paciente</label>
                <textarea style={{...s.input, minHeight: '80px', resize: 'vertical'}} value={formData.enderecoPaciente} onChange={e => setFormData({...formData, enderecoPaciente: e.target.value})} placeholder="Endereço completo..." required />
              </div>
            </div>

            <button style={s.btn} onClick={handleNext}>Continuar para IDA ➔</button>
          </div>
        )}

        {step === 2 && (
          <div>
            <h3 style={{fontSize: '1.1rem', marginBottom: '20px'}}>Seção 2: Deslocamento de IDA</h3>
            <label style={s.label}>Quantidade de transportes utilizados na IDA</label>
            <select style={s.input} value={formData.qtdTransportesIda} onChange={e => setFormData({...formData, qtdTransportesIda: Number(e.target.value)})}>
              <option value={1}>1 Transporte</option>
              <option value={2}>2 Transportes</option>
              <option value={3}>3 Transportes</option>
            </select>

            {[...Array(formData.qtdTransportesIda)].map((_, i) => renderTransportBlock('ida', i))}

            <button style={s.btnGhost} onClick={handlePrev}>⇦ Voltar</button>
            <button style={s.btn} onClick={handleNext}>Continuar para VOLTA ➔</button>
          </div>
        )}

        {step === 3 && (
          <div>
            <h3 style={{fontSize: '1.1rem', marginBottom: '20px'}}>Seção 3: Deslocamento de VOLTA</h3>
            <label style={s.label}>Quantidade de transportes utilizados na VOLTA</label>
            <select style={s.input} value={formData.qtdTransportesVolta} onChange={e => setFormData({...formData, qtdTransportesVolta: Number(e.target.value)})}>
              <option value={1}>1 Transporte</option>
              <option value={2}>2 Transportes</option>
              <option value={3}>3 Transportes</option>
            </select>

            {[...Array(formData.qtdTransportesVolta)].map((_, i) => renderTransportBlock('volta', i))}

            <button style={s.btnGhost} onClick={handlePrev}>⇦ Voltar</button>
            <button style={{...s.btn, background: '#10b981'}} onClick={handleSubmit} disabled={loading}>
              {loading ? 'Enviando...' : 'Finalizar e Enviar Formulário ✓'}
            </button>
          </div>
        )}
        </div>
      </div>
    </div>
  );
}
